import React from 'react'
import DocView from './doc-view/DocView'
import Modal from './prime-react-overrides/modal/Modal'
import PdfView from './pdf-view/PdfView'

function PreviewModal({ type, name, onHide, visible, documentData }) {
  let header = ['Preview']
  if (name) {
    header = name.split(".")[0]
  }
  let content = null

  if (type === 'application/pdf') {
    content = <PdfView fileLink={documentData} />
  }
  if (type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    content = <DocView docxData={documentData} />
  }
  if (type === 'image/jpeg'||type === 'image/png') {
    content = <div className='flex justify-content-center align-content-center '><img src={documentData} className="w-full" /></div>
  }

  return (
    <Modal visible={visible} className="PreviewModal" onHide={onHide} header={header} draggable={false} breakpoints={{ '640px': '100vw' }} style={{ width: '80vw' }}>
     {content}
    </Modal>
  )
}

export default PreviewModal